<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="width:100%;">
      <QueryContainer @search="handleSearch" @reset="handleReset" @export="handleExport">
        <template v-slot:searchContent>
          <SmallOrderSearchForm v-model="searchQuery"></SmallOrderSearchForm>
        </template>
        <div slot="listContent">
          <h1 class="page_title">小订订单</h1>
          <!-- 列表 -->
          <div class="page-list">
            <el-table :data="tableList" stripe v-loading="listLoading">
              <template v-for="column in tableColumns">
                <el-table-column :prop="column.props" :align="column.align || 'left'" :label="column.label"
                  :width="column.width" :min-width="column.minWidth" :fixed="column.fixed">
                  <template slot-scope="{row}">
                    <slot :name="column.props" :row="row">
                      <div v-if="column.props === 'customerName'" @click.stop.prevent="toDetailPage(row)"
                        style="color: #409EFF; cursor: pointer;">
                        {{ row.customerName || '' }}
                      </div>
                      <div v-else-if="column.props === 'customerPhone'">
                        <Desensitize
                          :text="row.customerPhone"
                          :userType="6"
                          :clearText="true"
                          :queryKey="row.id"
                          :key="row.id"
                        />
                      </div>
                      <div v-else>
                        {{ formatterColumnData(row, column) }}
                      </div>
                    </slot>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
          <!-- 分页 -->
          <div class="page-pagination">
            <el-pagination background layout="total, sizes, prev, pager, next" :total="total"
              :page-sizes="[10, 20, 30, 50]" :page-size="searchQuery.limit" :current-page="searchQuery.page"
              @size-change="handleSizeChange" @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </QueryContainer>
    </div>
  </div>
</template>

<script>
import { refundStatusMap, smallOrderStatusMap, datePickerOption } from './constants.js'
import SmallOrderSearchForm from './components/SmallOrderSearchForm.vue'
import Desensitize from "@/components/Desensitize/Desensitize.vue";

const columns = Object.freeze([
  { props: 'createdTime', label: '订单创建时间', minWidth: 140 },
  { props: 'AppPreOrderId', label: 'APP小订单号', minWidth: 120 },
  { props: 'appOrderId', label: '是否已转大定', minWidth: 100, formatter: (row, props) => row[props] ? '是' : '否' },
  { props: 'appOrderId', label: '关联大定订单编号', minWidth: 130, formatter: (row, props) => row[props] || '' },
  { props: 'customerName', label: '订车人姓名', minWidth: 90 },
  { props: 'customerPhone', label: '订车人电话', minWidth: 130 },
  { props: 'ownerName', label: '客户经理', width: 80 },
  { props: 'orderStatus', label: '订单状态', formatter: (row, props) => smallOrderStatusMap.get(row[props]), width: 80 },
  { props: 'seriesName', label: '订购车系', minWidth: 100 },
  { props: 'modelDisplay', label: '订购车型', minWidth: 100 },
  { props: 'paydownMoney', label: '小订订金', minWidth: 90, formatter: (row, props) => row[props] ? `${row[props]}元` : '' },
  { props: 'payTime', label: '支付时间', minWidth: 140 },
  { props: 'closeTime', label: '交易关闭时间', minWidth: 140 },
])

export default {
  components: {
    SmallOrderSearchForm,
    Desensitize
  },
  data() {
    return {
      refundStatusMap,
      smallOrderStatusMap,
      datePickerOption,
      listLoading: false,
      dealer: this.$common.getLoginInfo().profile,
      searchQuery: {
        page: 1,
        limit: 10,
        key: "",
        dateRange1: null,
        orderStatus: [],
        member: [],
        // seriesId: null,
        specIds: [],
        appSmallOrderId: "",
        hasTransferOrder: null,
        relatedOrderId: "",
        paymentDate: null,
        closeDate: null,
      },
      tableList: [],
      tableColumns: columns,
      total: 0,
      members: [],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let form = from.path;
      if (
        form === "/order/smallOrderDetail"
      ) {
        try {
          const listFilters = JSON.parse(sessionStorage.getItem("smallOrderDetail"));
          vm.searchQuery = listFilters.searchQuery;
          vm.total = listFilters.total;
        } catch (error) {
          console.log(error)
        }
      }
      vm.getList();
    });
  },
  mounted() { },
  methods: {
    formatterColumnData(row, column) {
      if (typeof column.formatter ===  'function') {
        return column.formatter(row, column.props)
      }
      return row[column.props]
    },
    handleSearch() {
      this.searchQuery.page = 1;
      this.getList();
    },
    // 重置
    handleReset() {
      this.searchQuery = {
        page: 1,
        limit: this.searchQuery.limit,
        key: "",
        dateRange1: null,
        orderStatus: [],
        member: [],
        // seriesId: null,
        specIds: [],
        appSmallOrderId: "",
        hasTransferOrder: null,
        relatedOrderId: "",
        paymentDate: null,
        closeDate: null,
      };
      this.handleSearch();
    },
    // 获取公共参数
    getCommonParams() {
      const { key, dateRange1, orderStatus, member, specIds, appSmallOrderId, hasTransferOrder, relatedOrderId, paymentDate, closeDate } = this.searchQuery
      return {
        dealerId: this.dealer.dealerId,
        key, // 姓名或手机号
        createdDate: { //创建时间
          start: dateRange1 != null ? dateRange1[0] : "",
          end: dateRange1 != null ? dateRange1[1] : "",
        },
        preOrderStatus: orderStatus.toString(),  //小定订单状态, 多个逗号分割
        // refundStatus: //退款状态, 多个逗号分割
        saleIds: member.length > 0 ? member.join(",") : "",  //销售顾问ID，多个逗号分隔
        // seriesId: seriesId || null,  //订购车系id
        specIds: specIds.length > 0
            ? specIds.map((item) => item[1]).join(",")
            : "",
        appPreOrderId: appSmallOrderId, // app 小定单号
        isBigOrder: hasTransferOrder || null,  // 是否转大定
        bigOrderId: relatedOrderId, // 大定单号
        payDate: {  //支付日期
          start: paymentDate != null ? paymentDate[0] : "",
          end: paymentDate != null ? paymentDate[1] : "",
        },
        closeDate: { //交易关闭日期
          start: closeDate != null ? closeDate[0] : "",
          end: closeDate != null ? closeDate[1] : "",
        },
      };
    },
    // 获取列表数据
    getList() {
      const { page, limit } = this.searchQuery
      let params = {
        ...this.getCommonParams(),
        pageStart: (page - 1) * limit,
        pageCount: limit,
      };
      this.listLoading = true;
      // TODO: 需要替换为小订订单的API接口
      this.$httpAuth
        .post("/v2/appCustomerService/preOrders", params)
        .then((response) => {
          const { data = [], total = 0 } = response.data || {}
          this.tableList = data;
          this.total = total;
        })
        .catch(() => { })
        .finally(() => {
          this.listLoading = false;
        });
    },
    handleSizeChange(val) {
      this.searchQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.searchQuery.page = val;
      this.getList();
    },
    toDetailPage(item) {
      const listFilters = {
        searchQuery: this.searchQuery,
        total: this.total
      };
      sessionStorage.setItem("smallOrderDetail", JSON.stringify(listFilters));
      sessionStorage.setItem("form", "order");
      sessionStorage.setItem("type", null);
      this.$router.push({
        path: "/order/smallOrderDetail",
        query: { smallOrderId: item.id },
      });
    },
    // 导出 接口暂不支持
    handleExport() {
      const loading = this.$loading({
        lock: true,
        text: '正在导出中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const params = this.getCommonParams();
      params.pageStart = 0;
      params.pageCount = 500;
      this.$httpAuth
        .post("/v2/appCustomerService/smallOrders", params)
        .then((response) => {
          const { file, total } = response.data;
          if (total > 500) {
            this.$message({
              customClass: 'export-message',
              dangerouslyUseHTMLString: true,
              message: '<div>最多只能导出500条数据</div>',
              duration: 2000
            });
          }
          setTimeout(() => {
            loading.close();
            var a = document.createElement('a');
            a.href = file;
            a.click();
          }, 1000);
        })
        .catch(() => {
          loading.close();
        });
    },
  },
};
</script>

